module.exports = __webpack_public_path__ + "img/video-play.cd070ad1.svg";